import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "../data/site";
import { Reveal } from "./Reveal";

export default function Reviews() {
  const [i, setI] = useState(0);
  const go = (d) => setI((prev) => (prev + d + REVIEWS.length) % REVIEWS.length);
  const r = REVIEWS[i];

  return (
    <section id="reviews" className="py-24 sm:py-32 bg-[#0D0D0D]" data-testid="reviews-section">
      <div className="container-lux">
        <Reveal className="max-w-3xl mb-12">
          <p className="overline mb-3">Customer Reviews</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight">
            Loved by homeowners <span className="text-gold-metallic">across the North West.</span>
          </h2>
        </Reveal>

        <div className="relative glass rounded-md p-8 sm:p-14 min-h-[280px] flex flex-col justify-center">
          <AnimatePresence mode="wait">
            <motion.div key={i}
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }} data-testid="review-card">
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, s) => <Star key={s} size={20} className="fill-[#D4AF37] text-[#D4AF37]" />)}
              </div>
              <p className="font-head text-2xl sm:text-3xl leading-snug tracking-tight text-[#F8F8F8]">“{r.text}”</p>
              <div className="mt-6 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-gradient-to-br from-[#AA8922] to-[#E5C869] flex items-center justify-center font-head text-black">{r.name[0]}</span>
                <div>
                  <p className="font-head uppercase tracking-tight text-sm">{r.name}</p>
                  <p className="text-xs text-[#C8C8C8]">{r.area} · via {r.platform}</p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="absolute top-6 right-6 flex gap-2">
            <button data-testid="review-prev" onClick={() => go(-1)} className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
              <ChevronLeft size={18} />
            </button>
            <button data-testid="review-next" onClick={() => go(1)} className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
              <ChevronRight size={18} />
            </button>
          </div>

          <div className="flex gap-2 mt-8">
            {REVIEWS.map((_, d) => (
              <button key={d} onClick={() => setI(d)} className={`h-1 rounded-full transition-all ${d === i ? "w-8 bg-[#D4AF37]" : "w-3 bg-white/20"}`} />
            ))}
          </div>
        </div>

        <div className="flex flex-wrap gap-6 mt-8 text-sm text-[#C8C8C8]">
          <span>★★★★★ Google Reviews</span>
          <span>★★★★★ Trustpilot</span>
          <span>★★★★★ Facebook Recommendations</span>
        </div>
      </div>
    </section>
  );
}
